import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {
	GET_NAME_FROM_LANE_AND_EQIUPMENT,
	IS_NOT_NULL_OR_UNDEFINED,
	ProjectDTO,
} from 'cargo-chief-commons';

@Component({
	selector: 'app-max-buy-dialog',
	templateUrl: './max-buy-dialog.component.html',
	styleUrls: ['./max-buy-dialog.component.scss'],
})
export class MaxBuyDialogComponent implements OnInit {
	maxBuyDetails: UntypedFormGroup;
	projectName: string = '-';
	lane: string = '-';
	project: ProjectDTO = null;
	currentMaxBuy: string = null;

	constructor(
		public dialogRef: MatDialogRef<MaxBuyDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: MaxBuyDialogInput,
		private formBuilder: UntypedFormBuilder
	) {}

	ngOnInit() {
		this.maxBuyDetails = this.formBuilder.group({
			maxBuy: ['', Validators.required],
		});
		if (IS_NOT_NULL_OR_UNDEFINED(this.data.project)) {
			this.project = this.data.project;
			this.projectName = this.project.name;
			this.lane = GET_NAME_FROM_LANE_AND_EQIUPMENT({
				originCity: this.project.originCity,
				originState: this.project.originState,
				destCity: this.project.destCity,
				destState: this.project.destState,
				equipmentType: this.project?.equipmentType || '',
			});
			this.currentMaxBuy = this.project.minRate ? `$ ${this.project.minRate / 100}` : '-';
		}
	}

	submitMaxBuy() {
		let payload = Object.assign({}, this.maxBuyDetails.value);
		payload.updatedMaxBuy = Number(payload.maxBuy) * 100;
		this.closeDialog(payload);
	}

	closeDialog(data?: { maxBuy: number } | null): void {
		this.dialogRef.close(data);
	}
}

interface MaxBuyDialogInput {
	project: ProjectDTO;
	title: string;
}
